import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from '../../../../components/BobTableContextMenu.module.css';

const SystemContextMenu = ({
    dataItem,
    history,
    setCoreSystem,
    setDeleteSystemModalOpen,
    setSelectedSystem,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditSite = system => {
        const path = '/v2/dashboard/core/entities/manage';

        const queryValues = queryString.parse(history.location.search);
        queryValues.entityType = 'system';
        queryValues.entityId = system.id;

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
        setCoreSystem(system);
    };

    const handleDeleteSystem = system => {
        setSelectedSystem(system);
        setDeleteSystemModalOpen(true);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    onClick={() => handleEditSite(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        edit
                    </span>
                    Edit
                </MenuItem>
                <MenuItem
                    onClick={() => handleDeleteSystem(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        do_not_disturb_on
                    </span>
                    Deactivate
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default withRouter(SystemContextMenu);
